import { useCallback } from 'react';
import { useUpdatePackagePurchaseMutation } from '@lingoda/monolith-graphql';
import { CouponForm } from './CouponForm';

export interface PaymentFormData {
    couponCode: string;
    paymentMethod: string;
    termsAndConditions: boolean;
    email: string;
    password?: string;
    marketing?: boolean;
    privacy?: boolean;
    agreements?: boolean[];
}

interface Props {
    purchaseId: string;
    appliedCode?: string;
    setAsyncValidating: (value: boolean) => void;
    keepInputAfterApply?: boolean;
    onApplySuccess?: () => void;
}

const CouponSection = ({
    purchaseId,
    appliedCode,
    setAsyncValidating,
    keepInputAfterApply,
    onApplySuccess,
}: Props) => {
    const [updatePackagePurchase] = useUpdatePackagePurchaseMutation({
        onCompleted: onApplySuccess,
    });

    const handleCouponChange = useCallback(
        (couponCode: string) => {
            return updatePackagePurchase({
                variables: {
                    couponCode,
                    id: purchaseId,
                },
            });
        },
        [purchaseId, updatePackagePurchase],
    );

    return (
        <CouponForm
            couponCode={appliedCode}
            onChange={handleCouponChange}
            onAsyncValidate={setAsyncValidating}
            keepInputAfterApply={keepInputAfterApply}
        />
    );
};

export default CouponSection;
